export default [
     {
          path: '/process',
          name: 'Process',
          component: () => import("@/views/Page/Process/Process.vue"),
          meta: {
               title: '#Default# | Process'
          },
     }
];